export default __webpack_public_path__ + "static/media/Gloria_Romero.900d6c01.jpg";